<template>
	<modal name="carModelViewPopup" :width="850" :height="550" :clickToClose="false" @opened="opened">
		<div id="menu_pop11" class="popup on" style="left: 535px; top: 187.5px; display: block;">
			<div class="pop_tit">
				차량모델 보기
			</div>
			<div class="pop_con_wrap">
				<div class="scroll_area mCustomScrollbar _mCS_9 mCS_no_scrollbar" style="height: 400px;">
					<div id="mCSB_9" class="mCustomScrollBox mCS-dark-thick mCSB_vertical mCSB_inside" tabindex="0" style="max-height: none;">
						<div id="mCSB_9_container" class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" style="position:relative; top:0; left:0;" dir="ltr">
							<div class="pop_con_bg">
								<!-- Swiper -->
								<!--  -->
								<div class="modelImg">
									<img :src="imageUrl + '' + imageFileNo" />
								</div>
									<!--  -->
								</div>
							</div>
							<div id="mCSB_9_scrollbar_vertical" class="mCSB_scrollTools mCSB_9_scrollbar mCS-dark-thick mCSB_scrollTools_vertical" style="display: none;">
								<div class="mCSB_draggerContainer">
									<div id="mCSB_9_dragger_vertical" class="mCSB_dragger" style="position: absolute; min-height: 30px; top: 0px; height: 0px;">
										<div class="mCSB_dragger_bar" style="line-height: 30px;">
										</div>
									</div>
									<div class="mCSB_draggerRail">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="pop_footer_wrap">
					<div class="btn_area mt0">
						<a href="javascript:void(0);" class="button blue" @click="close"><span>확인</span></a>
					</div>
				</div>
				<a href="javascript:void(0);" title="close" class="pop_close" @click="close">close</a>
			</div>
	</modal>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
	name: 'CarModelViewPopup',
	data() {
		return {
      USER_AUTH : AppConfig.USER_AUTH,
			imageFileNo: ''
		}
	},
	props: {
		value: ''
	},
	methods: {
		opened() {
			Vue.httpClient
      .get('/common/product/detail', { params : { productNo : 4 }})
      .then((response) => {
				console.log(response)
				this.imageFileNo = 11;
			console.log(this.imageUrl + '' + this.imageFileNo)
      });

      // close 버튼 표시를 위해 반드시 필요
      $("#menu_pop11").parent().css('overflow', 'visible');

      // content scroll
      $("#scroll_area").mCustomScrollbar( {
        theme: "dark-thick",
        scrollInertia: 500
      });

		},
    close() {
      this.$modal.hide('carModelViewPopup');
		}
	},
	mounted() {
		/*
		Vue.httpClient
		.get('')
		.then((result) => {
			var imgSrc = result.aaa.bbb;
			this.carImage = {
				/* imgSrc
				1. 'background-image': 'url(' + require(imgSrc) + ')' 적용시 
					Critical dependency: the request of a dependency is an expression 문제 발생
				2. img를 어디서 불러오는지 확인 필요
				*
			};
		})
		.catch((error) => {
			this.carImage = {
				// @/assets/images/img_interview01.jpg
				'background-image': 'url(' + require('@/assets/images/img_interview01.jpg') + ')'
			};
		}); */
	},
  computed: {
    imageUrl () {
      return AppConfig.HTTP_CONFIG.baseURL + '/common/image?xAuthToken=' + window.$store.getters['Login/getToken'] + '&imageFileNo='
    },
    token () {
      return window.$store.getters['Login/getToken']
		}
	}

}
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/views/common/CarModelViewPopup.vue